import { HashRouter, Redirect, Route } from 'react-router-dom';
import './views/ModalTicket.css'
import ModalHeader from './components/ModalHeader';
import TicketSidebar from './views/TicketSidebar';
import Informacoes from './views/Informacoes';
import Historico from './views/Historico';
import Pagamento from './views/Pagamento';
import Items from './views/Items';
import Rastreio from './views/Rastreio';
import Table from './views/Table';
import CreateTicketButton from './components/CreateTicketButton';
import DispatchContextProvider from './contexts/OrderContext';
import CreateTicket from './views/CreateTicket';
import ModalTicket from './views/ModalTicket';
import Loading from './components/Loading';

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Route path='/config'>
          <ModalTicket />
        </Route>
        <Route path='/modal'>
          <DispatchContextProvider>
            <Route exact path='/modal/informacoes'>
              <ModalHeader />
              <Informacoes/>
              <CreateTicketButton/>
            
            </Route>
            <Route exact path='/modal/historico'>
              <ModalHeader />
              <Historico/>
              <CreateTicketButton/>
            
            </Route>

            <Route exact path='/modal/pagamento'>
              <ModalHeader />
              <Pagamento/>
              <CreateTicketButton/>
            </Route>

            <Route exact path='/modal/items'>
              <ModalHeader />
              <Items/>
              <CreateTicketButton/>
            </Route>

            <Route exact path='/modal/rastreio'>
              <ModalHeader />
              <Rastreio/>
              <CreateTicketButton/>
            </Route>

            <Route exact path='/modal/criarTicket'>
              <ModalHeader />
              <CreateTicket />
            </Route>

            <Route exact path='/modal'>
              <div id="router-load">
                <Loading />
              </div>
            </Route>
          </DispatchContextProvider>

        </Route>
       
        <Route exact path='/ticket_sidebar'>
          <TicketSidebar/>
        </Route>
        <Route exact path='/nav_bar'>
          <Table/>
        </Route>
        <Route exact path='/view'>
        <Redirect to='/informacoes'></Redirect>
        </Route>
        
      </HashRouter>
    </div>
  );
}

export default App;
